import { render, staticRenderFns } from "./CreditRequestsBlock.vue?vue&type=template&id=1a5f4bf2&scoped=true&"
import script from "./CreditRequestsBlock.vue?vue&type=script&lang=js&"
export * from "./CreditRequestsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CreditRequestsBlock.vue?vue&type=style&index=0&id=1a5f4bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f4bf2",
  null
  
)

component.options.__file = "CreditRequestsBlock.vue"
export default component.exports